// import Vue from "vue";
import axios from 'axios'
import qs from 'qs'; // 引入qs模块，用来序列化post类型的数据，后面会提到
import router from '@/router/index';
import {
  Message,
  Loading
} from 'element-ui'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
let service = axios.create({
  baseURL: BASE_URL,
  timeout: 300000
})
//添加请求拦截器
service.interceptors.request.use(config => {
  if(config.url!=='/fillmed-club-auth/user/login'){
    let token = localStorage.getItem('token');
    config.headers['Authorization'] = token ? 'Bearer ' + token : ''
  }
  // if(store.getters.token){
  //     config.headers['TOKEN']=getCookie('TOKEN')
  // }
  return config
}, function(error) {
  return Promise.reject(error)
})
//添加响应拦截器
service.interceptors.response.use(response => {
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
   */
  let res = response.data;
  // if (!res.flag) {
  //   Message({
  //     message: res.message,
  //     type: 'error',
  //     duration: 5 * 1000
  //   })
  // }
  return res


}, error => {
  console.log('error', error)
  Message({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  })
  return Promise.reject(error)
})


//post请求
export let exportPost = (url, param={}) => {

  return new Promise((resolve, reject) => {
    service({
      method: 'post',
      url,
      data: param,
      responseType: 'blob'

    }).then(res => {
      // console.log('res', res)

      resolve(res)
    }).catch(err => {

      console.log(err)

    })
  })
};



// WEBPACK FOOTER //
// ./src/api/export.js